import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { LocalizationService } from '../services/localization/localization.service';

@Injectable({
  providedIn: 'root'
})
export class LocaleResolver implements Resolve<string | undefined> {
  constructor(private localizationService: LocalizationService) {}

  resolve(next: ActivatedRouteSnapshot) {
    let locale =
      next.queryParams.lang || next.data.locale || next.params.locale;
    if (locale === 'en') {
      locale = 'en-US';
    }
    this.localizationService.locale.next(locale);
    return locale;
  }
}
